// Load Web Awesome styles + components once
import "mapbox-gl/dist/mapbox-gl.css";
import "./styles/global.css";
import "./webawesome";

import React from "react";
import ReactDOM from "react-dom/client";

import { initPlausible } from "./analytics/plausible";
import Router from "./router";

initPlausible();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);
